
<div class="container ">
  <div class="row"  data-aos="fade-up"
       >
    <div class="col-md-12" >
      <h3 style="text-align: center;font-family: Tangerine,serif;font-size: 60px;margin:20px">
        Parcours</h3>
      <ul class="nav nav-pills nav-fill mb-3" id="pills-tab" role="tablist" style="font-family: Tangerine,serif;font-size: 30px">
        <li class="nav-item">
          <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home"
             role="tab" aria-controls="pills-home" aria-selected="true"><span class="fa fa-calendar"></span> 2017 - 2018 </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile"
             role="tab" aria-controls="pills-profile" aria-selected="false">
             2018 <span class="fa fa-calendar"></span> 2019</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="pills-contact-tab" data-toggle="pill"
             href="#pills-contact" role="tab" aria-controls="pills-contact"
             aria-selected="false">  2019 - 2020 <span class="fa fa-calendar"></span></a>
        </li>
      </ul>
      <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
             aria-labelledby="pills-home-tab" data-aos="zoom-out">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <h6 style="text-align: center"><span class="fa fa-calendar"></span> September 2017 To June 2018</h6><br>
                <div class="row" style="padding-left: 200px;padding-right: 200px">
                  <div class="col-md-2"></div>
                  <div class="col-md-8" style="    border-top: 2px solid black;">
                 </div>
                  <div class="col-md-2"></div>
                </div><br>
                <div class="row">
                  <div class="col-md-1"></div>
                  <div class="col-md-3"><img src="./assets/images/morocco2.svg" alt="Casablanca City" height="150px">
                    <br>    <h5> <span class="fa fa-map-marker"></span> Casablanca City</h5></div>
                  <div class="col-md-7" style="text-align: center">
                    <h3>Web Developer at Alumni Tech Group</h3>
                    <p>Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem
                      Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem</p>
                    <ul>
                      <li>Tache 1</li>
                      <li>Tache 2</li>
                    </ul>
                  </div>
                  <div class="col-md-1"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="tab-pane fade" id="pills-profile"
             role="tabpanel" aria-labelledby="pills-profile-tab" data-aos="zoom-out">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <h6 style="text-align: center"><span class="fa fa-calendar"></span> September 2018 To June 2019</h6><br>
                <div class="row" style="padding-left: 200px;padding-right: 200px">
                  <div class="col-md-2"></div>
                  <div class="col-md-8" style="    border-top: 2px solid black;">
                  </div>
                  <div class="col-md-2"></div>
                </div><br>
                <div class="row">
                  <div class="col-md-1"></div>
                  <div class="col-md-3"><img src="./assets/images/morocco.svg" alt="Marrakech City" height="150px">
                    <br>    <h5> <span class="fa fa-map-marker"></span> Marrakech City</h5></div>
                  <div class="col-md-7" style="text-align: center">
                    <h3>Web Developer at Alumni Tech Group</h3>
                    <p>Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem
                      Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem</p>
                    <ul>
                      <li>Tache 1</li>
                      <li>Tache 2</li>
                    </ul>
                  </div>
                  <div class="col-md-1"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="pills-contact" role="tabpanel"
             aria-labelledby="pills-contact-tab" data-aos="zoom-out">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <h6 style="text-align: center"><span class="fa fa-calendar"></span> September 2019 To June 2020</h6><br>
                <div class="row" style="padding-left: 200px;padding-right: 200px">
                  <div class="col-md-2"></div>
                  <div class="col-md-8" style="    border-top: 2px solid black;">
                  </div>
                  <div class="col-md-2"></div>
                </div><br>
<div class="row">
  <div class="col-md-1"></div>
  <div class="col-md-3"><img src="./assets/images/morocco.svg" alt="Marrakech City" height="150px">
    <br>  <h5> <span class="fa fa-map-marker"></span> Marrakech City</h5></div>
  <div class="col-md-7" style="text-align: center">
    <h3>Web Developer at Alumni Tech Group</h3>
    <p>Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem
      Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem</p>
    <ul>
      <li>Tache 1</li>
      <li>Tache 2</li>
    </ul>
  </div>
  <div class="col-md-1"></div>
</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


